import * as React from 'react';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { compose, withProps } from 'recompose';
import { format } from 'date-fns';
import { Card } from 'material-ui/Card';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';
import { InputField, Input } from '@components/form';

import { getError } from '@modules/errors/_errorsActions';
import * as T from '@modules/errors/_errorsTypes';

export const enhance = compose<T.ErrorFormProps, T.OutterProps>(
  entityDetailEnhancer<T.ErrorEnhancerProps<T.Error>, T.Error>({
    getEntity: getError,
    defaultEntity: {}
  }),
  breadcrumbs(() => [{ label: 'Detail' }]),
  withProps<{}, T.ErrorFormProps>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    maxYear: format(new Date(), 'YYYY')
  })),
  reduxForm({
    form: 'module-tickets'
  })
);

export const View: React.SFC<T.OutterProps & T.ErrorFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                disabled={true}
                multiLine={true}
                rowsMax={10}
                name="message"
                id="message"
                label={'Zpráva'}
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                disabled={true}
                multiLine={true}
                rowsMax={10}
                name="stackTrace"
                id="stackTrace"
                label={'Cesta k chybě'}
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                disabled={true}
                multiLine={true}
                rowsMax={10}
                name="userAgent"
                id="userAgent"
                label={'Uživatelský agent'}
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                disabled={true}
                multiLine={true}
                rowsMax={10}
                name="url"
                id="url"
                label={'Url adresa'}
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
              />
            </Col>
          </Row>
        </Grid>
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
      </Card>
    </form>
  </div>
);

export const ErrorsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/errors/ErrorsForm.tsx